<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/v5/4chap1#chap1">Feb. 12</a></p>
<p class="toc1"><a href="#/Book1/v5/5chap2#chap2">During Homeroom, F the 13</a></p>
<p class="toc1"><a href="#/Book1/v5/6chap3#chap3">Feb. 14, Sat. Morning</a></p>
<p class="toc1"><a href="#/Book1/v5/7chap4#chap4">Sur La Plage</a></p>
<p class="toc1"><a href="#/Book1/v5/8chap5#chap5">Feb. 15</a></p>
<p class="toc1"><span href="#/Book1/v5/9chap6#chap6" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1"><span href="#/Book1/v5/10chap7#chap7" title="Link target outside of Sample">In Which Ducky McCrae</span></p>
<p class="toc1"><span href="#/Book1/v5/11chap8#chap8" title="Link target outside of Sample">Sometimes You Wish</span></p>
<p class="toc1"><span href="#/Book1/v5/12chap9#chap9" title="Link target outside of Sample">A Passage of Several Days</span></p>
<p class="toc1"><span href="#/Book1/v5/13chap10#chap10" title="Link target outside of Sample">Saturday at Venice Beach</span></p>
<p class="toc1"><span href="#/Book1/v5/14chap11#chap11" title="Link target outside of Sample">In the Kitchen</span></p>
<p class="toc1"><span href="#/Book1/v5/15chap12#chap12" title="Link target outside of Sample">The Great McCrae</span></p>
<p class="toc1"><span href="#/Book1/v5/16chap13#chap13" title="Link target outside of Sample">The Morning After</span></p>
<p class="toc1"><span href="#/Book1/v5/17chap14#chap14" title="Link target outside of Sample">It Is Two A.M.</span></p>
<p class="toc1"><span href="#/Book1/v5/18chap15#chap15" title="Link target outside of Sample">2:15Still.</span></p>
<p class="toc1"><span href="#/Book1/v5/19chap16#chap16" title="Link target outside of Sample">2:23</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?8324945c